var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileDiagonal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e80c7e32-ebf4-4b0d-9843-881013410e08",
    "data-name": "ab6ed1d0-fbb1-4b8b-bb20-92dbdd21e829",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 374.54 293.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e55c44d2-edd5-455b-92fd-9b30169f3a7d{fill:#fff;}.af32e859-793e-46bb-8e5a-f3a4654eb40d{fill:#c76a3c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "e55c44d2-edd5-455b-92fd-9b30169f3a7d",
    d: "M0,60,374.54,0V284.5H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "af32e859-793e-46bb-8e5a-f3a4654eb40d",
    d: "M0,69,374.54,9V293.5H0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDiagonal);
export default __webpack_public_path__ + "static/media/mobile-diagonal.b44caa31df7a5e24a18ba48eaaf1c204.svg";
export { ForwardRef as ReactComponent };